<template>
    <div class="container py-4">
        <div class="row">
            <div class="col-8">
                <h2 class="mb-4">New podio user</h2>
                <router-link :to="{name: 'podioUserIndex'}" class="btn btn-outline-dark btn-sm mb-3">All podio users</router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="alert alert-success" role="alert" v-if="success">
                    Podio user successfully created!
                </div>
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="form-group">
                                <label for="user_id">User id*</label>
                                <input class="form-control" id="user_id" name="user_id"
                                       placeholder="Enter user id"
                                       type="text"
                                       v-bind:class="[this.user_id.validated ? this.user_id.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.user_id"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('user_id') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="name">Name*</label>
                                <input class="form-control" id="name" name="name"
                                       placeholder="Enter full name"
                                       type="text"
                                       v-bind:class="[this.name.validated ? this.name.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.name"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('name') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="type">Type*</label>
                                <select id="type" class="form-control" v-model="form.type">
                                    <option v-for="type in USER.contacts"
                                            :value="type.id"
                                            :key="type.id"
                                            >
                                        {{type.name}}
                                    </option>
                                </select>
                            </div>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'
    import {mapGetters} from 'vuex'

    export default {
        name: 'podioUserCreate',
        data() {
            return {
                success: false,
                error: '',
                checkbox: true,
                form: {
                    user_id: '',
                    name: '',
                    type: 'am'
                }
            }
        },
        computed: {
            ...mapFields(['user_id', 'name', 'type']),
            ...mapGetters(['USER'])
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //Moet in array voor backend
                        this.$store.dispatch('SAVE_PODIO_USER', this.form)
                            .then(() => {
                                this.success = true
                                //Form leegmaken
                                this.form = {}
                                this.$validator.reset()
                            })
                            .catch((error) => {
                                if (error.errors.user_id) {
                                    this.$validator.errors.add({
                                        field: 'user_id',
                                        msg: error.errors.user_id[0]
                                    })
                                    this.fieldsVee.user_id.valid = false
                                }
                            })
                    }
                })
            },
        }
    }
</script>
